import React from 'react';
import Svg from '@justgiving/svg';
import qrIcon from '@justgiving/icons/lib/qr-code.svg';
import IconButton from '../IconButton/IconButton';
import urljoin from 'url-join';

import styles from './QrCodeShareButton.scss';
import { usePageMeta } from '../../hooks';

export interface QrCodeShareProps {
  onClick: () => void;
}

export const QrCodeShareButton: React.FunctionComponent<QrCodeShareProps> = ({
  onClick = () => {},
}) => {
  const { currentUrl } = usePageMeta();

  function navigateToQrCode() {
    onClick();
    window.location.href = urljoin(currentUrl, '/qrcode');
  }

  return (
    <IconButton
      className={styles.qrCodeButton}
      onClick={() => navigateToQrCode()}
    >
      <div>
        <Svg className={styles.icon} markup={qrIcon} />
      </div>
      <span className={styles.qrCodeText}>QR Code</span>
    </IconButton>
  );
};
